import ReduxToolkit, { createSlice } from '@reduxjs/toolkit';

const NAME = 'lastCheckTimestamp';

export type ValueType = number;

const initialState: ValueType = null;

const setAction: ReduxToolkit.CaseReducer<
	ValueType,
	ReduxToolkit.PayloadAction<ValueType>
> = (state, action) => {
	return action.payload;
};

export const lastCheckTimestampSlice = createSlice({
	name: NAME,
	initialState,
	reducers: {
		setLastCheckTimestamp: setAction,
	},
});
